import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const TABS = [
  { id: "about", label: "About Us" },
  { id: "terms", label: "Terms" },
  { id: "contact", label: "Contact" },
];

export default function ContentAdmin() {
  const [key, setKey] = useState("about");
  const { data, isLoading, refetch } = useQuery({ queryKey: ["page", key], queryFn: () => api.getPage(key) });
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (data) setForm(data); }, [data]);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    setSaving(true);
    try {
      await api.updatePage(key, form);
      toast.success("Page saved");
      refetch();
    } catch (err) { toast.error(err.message); } finally { setSaving(false); }
  };

  const inputCls = "w-full h-11 rounded-lg border border-line px-3 text-sm focus:outline-none focus:border-brand";

  return (
    <div>
      <h2 className="font-display text-2xl text-ink mb-4">Content Pages</h2>
      <div className="flex gap-2 mb-5">
        {TABS.map((t) => (
          <button key={t.id} onClick={() => setKey(t.id)} data-testid={`content-tab-${t.id}`} className={`h-9 px-4 rounded-full text-sm font-semibold border ${key === t.id ? "bg-brand text-white border-brand" : "border-line text-muted2"}`}>{t.label}</button>
        ))}
      </div>

      {isLoading ? (
        <p className="text-muted2">Loading…</p>
      ) : key === "contact" ? (
        <div className="space-y-3 max-w-xl">
          <textarea value={form.intro || ""} onChange={set("intro")} rows={2} placeholder="Intro text" className="w-full rounded-lg border border-line px-3 py-2 text-sm focus:outline-none focus:border-brand" data-testid="content-intro" />
          <input value={form.phone || ""} onChange={set("phone")} placeholder="Phone" className={inputCls} data-testid="content-phone" />
          <input value={form.email || ""} onChange={set("email")} placeholder="Email" className={inputCls} data-testid="content-email" />
          <textarea value={form.address || ""} onChange={set("address")} rows={2} placeholder="Address" className="w-full rounded-lg border border-line px-3 py-2 text-sm focus:outline-none focus:border-brand" data-testid="content-address" />
        </div>
      ) : (
        <textarea value={form.content || ""} onChange={set("content")} rows={16} placeholder="Page content…" className="w-full rounded-lg border border-line px-3 py-3 text-sm leading-relaxed focus:outline-none focus:border-brand" data-testid="content-body" />
      )}

      <button disabled={saving} onClick={save} className="mt-4 h-11 px-6 rounded-full bg-brand text-white font-semibold flex items-center gap-2 disabled:opacity-60" data-testid="content-save">
        {saving ? <Loader2 className="animate-spin" size={18} /> : "Save page"}
      </button>
    </div>
  );
}
